<template>
  <div class="categories-filter">
        <div @click="collapse" class="title-container">
            <p class="title">Product Type <span v-if="!selectedCategories.includes('View All')">({{selectedCategories.length}})</span></p>
            <p class="icon">{{plusIcon}}</p>
        </div>
        <div v-if="!collapsed" class="checkbox-container">
            <div @click="addCategory(categories.title)" class="checkbox-button" v-for="categories of currentCategories" :key="categories.title">
                <input :value="categories.title" type="checkbox" :checked="selectedCategories.includes(categories.title)">
                <p :class="categories.title == 'Sale' ? 'red' : ''">{{categories.title}}</p>
            </div>
        </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import smoothReflow from 'vue-smooth-reflow'
export default {
    mixins: [smoothReflow],
    data() {
        return{
            collapsed: true,
        }
    },
    computed: {
        ...mapGetters([
            'categories'
        ]),
        selectedCategories: {
            get(){return this.$store.state.selectedCategoriesMobile},
            set(value){this.$store.commit('setSelectedCategoriesMobile', value )}
        },
        currentCategories(){
            return this.categories.filters;
        },
        plusIcon(){
            return this.collapsed == true ? '+' : '-';
        }
    },
    methods: {
        collapse(){
            this.collapsed = !this.collapsed;
        },
        addCategory(value){
            this.selectedCategories = value;
        }
    },
    mounted(){
        this.$smoothReflow();
    },
}
</script>

<style scoped>
.categories-filter{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: white;
    box-shadow: inset 0px -1px 0px #E6E8EC;
}

.icon{
    cursor: pointer;
    font-size: 1rem;
}

.title-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding: 2% 5%;
}
.title{
    color: #0F0C38;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 700;
    font-size: 1.3vw;
    line-height: 1.5;
}

.checkbox-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0% 0% 3% 5%;
    width: 100%;
    overflow: hidden;
}

.occasion-title{
    color: #0F0C38;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 700;
    font-size: 1.2vw;
    line-height: 1.43;
}

.checkbox-button{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 1% 0%;
}

.checkbox-button p{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1.2vw;
    line-height: 1.43;
    color: #0F0C38;
}

.checkbox-button .red{
    color: red;
}

@media screen and (max-width: 767px){
    .title{
        font-size: 1.2rem;
    }

    .icon{
        font-size: 2rem;
    }

    .title-container{
        font-size: 1rem;
    }

    .occasion-title{
        font-size: 1rem;
    }

    .checkbox-button p{
        font-size: 1rem;
    }
}
</style>